document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.text-with-icons__list.mobile-slider').forEach((slider) => {
    const slides = slider.querySelectorAll('.ds-text-with-icons__item');
    if (slides.length < 2) return;

    let index = 0;
    slides[0].classList.add('is-active');

    setInterval(() => {
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
    }, 2500);
  });
});
